import { type PropsWithChildren, type ReactNode } from "react";

import {
  MouseParallaxChild,
  MouseParallaxContainer,
} from "react-parallax-mouse";

import Ring from "@/assets/img/gradient-ring.svg?react";
import Logo from "@/assets/logos/kazaar_logo.svg?react";
import { randomRange } from "@/helpers/randomRange";

export type UserHasNoOrganisationPageWrapperProps = {
  children: ReactNode;
} & PropsWithChildren;

export const UserHasNoOrganisationPageWrapper = ({
  children,
}: UserHasNoOrganisationPageWrapperProps) => {
  const springConfig = {
    tension: 120,
    friction: 14,
    precision: 0.01,
    velocity: 2,
    mass: randomRange(1, 3),
  };

  return (
    <MouseParallaxContainer
      className="relative flex h-screen w-screen items-center justify-center overflow-hidden"
      containerStyle={{
        background:
          "radial-gradient(50% 50% at 50% 50%, rgba(172, 0, 134, 0.1) 0%, rgba(172, 0, 134, 0) 100%), radial-gradient(50% 50% at 50% 50%, rgba(14, 9, 165, 0.1) 0%, rgba(14, 9, 165, 0) 100%)",
        backgroundSize: "2000px 2000px, 2000px 2000px",
        backgroundPosition: "-100% 0, 300% 100%",
      }}
      globalFactorX={0.1}
      globalFactorY={0.1}
      springConfig={springConfig}
    >
      <MouseParallaxChild
        className="pointer-events-none absolute -bottom-[5%] -left-[5%] z-10"
        factorX={0.5}
        factorY={0.2}
      >
        <div style={{ transform: "scale(1.4)" }}>
          <Ring />
        </div>
      </MouseParallaxChild>

      <MouseParallaxChild
        className="pointer-events-none absolute -top-[2%] right-0 z-10"
        factorX={0.1}
        factorY={0.4}
      >
        <div style={{ transform: "scale(2.2)" }}>
          <Ring />
        </div>
      </MouseParallaxChild>

      <Logo className="absolute top-16 z-20 w-[182px]" />

      <div className="z-20 flex h-[60vh] max-h-[450px] min-h-[400px] w-[60vw] min-w-[250px] max-w-[800px] flex-col items-center justify-center rounded-2xl bg-white px-[6vw] pb-[60px] pt-[50px]">
        {children}
      </div>
    </MouseParallaxContainer>
  );
};
